/*
 * Copyright © 2022 EPO: European Patent Office.
 * ALL RIGHTS RESERVED
 */

import { useConfiguration } from '../redux/features/configuration/useConfiguration';
import { ConfigResourceProps } from '../redux/enums/ConfigResourceProps';

/**
 * Helper hook for procedures
 * The result delivers the procedure object of the current URL procedure.
 */
export default function useProcedures() {
  const {
    resource: { procedures },
  } = useConfiguration(ConfigResourceProps.GLOBAL_CONFIGURATION);

  const getProcedure = procedureId => procedures[procedureId];

  return {
    procedures,
    getProcedure,
  };
}
